module.exports = "<div fxLayout=\"row\" fxLayoutAlign=\"start center\" fxFlexFill>\n  {{formattedAddress()}}\n</div>\n"